export enum IndicatorCategoryTab {
  ALL = 0,
  PEOPLE = 1,
  REWARDING = 2,
  PERFORMANCE = 3,
  DEVELOPMENT = 4,
  CUSTOM = 5,
}
